import React, { useContext } from "react";
import themeContext from "../../../../context/theme/ThemeContext";

const ReportHistoryIcon = () => {
  const { getThemeColor } = useContext(themeContext);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M15.9562 12.6525L16.8112 11.9025L16.0612 10.605L14.9737 10.9725C14.7337 10.77 14.4637 10.6125 14.1637 10.5L13.9387 9.375H12.4387L12.2137 10.4925C11.9137 10.605 11.6437 10.7625 11.4037 10.965L10.3162 10.5975L9.56622 11.895L10.4212 12.645C10.3612 13.02 10.3612 13.215 10.4212 13.59L9.56622 14.34L10.3162 15.6375L11.4037 15.27C11.6437 15.4725 11.9137 15.63 12.2137 15.7425L12.4387 16.875H13.9387L14.1637 15.7575C14.4637 15.645 14.7337 15.4875 14.9737 15.285L16.0612 15.6525L16.8112 14.355L15.9562 13.605C16.0162 13.2225 16.0162 13.0275 15.9562 12.6525ZM13.1887 14.625C12.3637 14.625 11.6887 13.95 11.6887 13.125C11.6887 12.3 12.3637 11.625 13.1887 11.625C14.0137 11.625 14.6887 12.3 14.6887 13.125C14.6887 13.95 14.0137 14.625 13.1887 14.625ZM7.18872 4.125V8.1825L8.95872 9.9525L9.73872 8.61L8.68872 7.5675V4.125H7.18872ZM14.6887 7.875C14.6887 4.1475 11.6662 1.125 7.93872 1.125C5.81622 1.125 3.92622 2.115 2.68872 3.645V1.875H1.18872V6.375H5.68872V4.875H3.63372C4.58622 3.5175 6.16122 2.625 7.93872 2.625C10.8337 2.625 13.1887 4.98 13.1887 7.875H14.6887ZM7.08372 13.0575C4.84122 12.69 3.07122 10.8825 2.74872 8.625H1.23372C1.60872 12 4.46622 14.625 7.93872 14.625C7.95372 14.625 7.97622 14.625 7.99122 14.625L7.08372 13.0575Z"
        fill={getThemeColor("icon-color")}
      />
    </svg>
  );
};

export default ReportHistoryIcon;
